import { fetcher, PaginationResponse } from "@/shared/core-configs";
import { LocalProduct } from "../types/LocalProduct";
import { API } from "@/config";
import { useQuery } from "@tanstack/react-query";
import { Pagination } from "@/core/common/types";
import qr from "query-string";
import type { StockStatus } from "@/utils/stockFilters";
export const GET_EXTERNAL_PRODUCTS_FETCH_KEY = "getExternalProducts";

export type { StockStatus };

type GetLocalProductsParams = {
  zoneId?: string;
  showDisabled?: boolean;
  searchTerm?: string;
  sort?: string;
  order?: string;
  stockStatus?: StockStatus;
  storageId?: string;
} & Partial<Pagination>;

export const getExternalProducts = async (
  zoneId?: string,
  page = 1,
  pageSize = 10,
  showDisabled = false,
  searchTerm?: string,
  sort?: string,
  order?: string,
  stockStatus?: StockStatus,
  storageId?: string,
) => {
  const params = qr.stringify({
    zoneId,
    page,
    pageSize,
    showDisabled,
    searchTerm,
    sort,
    order,
    stockStatus,
    storageId,
  });
  const response = await fetcher.get(
    `${API.GESLUB}/external-product?${params}`,
  );
  return response.data;
};

export const useGetExternalProducts = ({
  zoneId,
  page,
  pageSize,
  showDisabled,
  searchTerm,
  sort,
  order,
  stockStatus,
  storageId,
}: GetLocalProductsParams = {}) => {
  const { data, error, isPending, refetch } = useQuery<
    PaginationResponse<LocalProduct>,
    Error
  >({
    queryKey: [
      GET_EXTERNAL_PRODUCTS_FETCH_KEY,
      zoneId,
      page,
      pageSize,
      showDisabled,
      searchTerm,
      sort,
      order,
      stockStatus,
      storageId,
    ],
    queryFn: () =>
      getExternalProducts(
        zoneId,
        page,
        pageSize,
        showDisabled,
        searchTerm,
        sort,
        order,
        stockStatus,
        storageId,
      ),
    placeholderData: (prev) => prev,
  });
  return {
    data: data?.data || [],
    pagination: data?.pagination,
    error,
    isPending,
    refetch,
  };
};
